import { computed, defineComponent } from "vue";
import Badge from "@/components/ui/badge/Badge";
import Tooltip from "@/components/ui/tooltip/Tooltip";
import { $t } from "@/services/i18n";
import { p } from "@/utils/props-builder";

const props = {
  difficulty: p.$number(),
};

export default defineComponent({
  name: "DifficultyBadge",
  props,
  setup(props) {
    const config = computed(() => {
      switch (props.difficulty) {
        case 1:
          return {
            color: "green" as const,
            label: $t("agents:templates.difficulty.beginner"),
            stars: 1,
          };
        case 2:
          return {
            color: "amber" as const,
            label: $t("agents:templates.difficulty.intermediate"),
            stars: 2,
          };
        case 3:
          return {
            color: "red" as const,
            label: $t("agents:templates.difficulty.advanced"),
            stars: 3,
          };
        default:
          return { color: "gray" as const, label: "", stars: 0 };
      }
    });

    return () => (
      <Tooltip text={config.value.label}>
        <Badge color={config.value.color} variant="subtle" size="xs">
          {"★".repeat(config.value.stars)}
          {"☆".repeat(3 - config.value.stars)}
        </Badge>
      </Tooltip>
    );
  },
});
